import styled from 'styled-components';

import { ds } from '@/config/colors';
import { media } from '@/utils/mediaQueries';

/* Pasek akcji pod formularzem, jak w ustawieniach outletu: przyciski po prawej,
   czarny pill „Zapisz". Bez przyklejania do dołu ekranu, ma zamykać formularz. */

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 20px;
  /* Odstęp pod przyciskami jako padding (margines ostatniego dziecka potrafi zniknąć w kontenerze
     z przewijaniem), żeby stopka nie przyklejała się do dolnej krawędzi strony. */
  padding-bottom: 48px;
  border-top: 1px solid ${ds.borderDefault};

  /* Telefon: przyciski po równo na całą szerokość, mniejszy odstęp pod spodem (dalej jest stopka). */
  ${media.mobile} {
    padding-bottom: 24px;

    & > button {
      flex: 1 1 0;
      min-width: 0;
    }
  }
`;

const buttonBase = `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 44px;
  padding: 0 20px;
  border-radius: 9999px;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PrimaryButton = styled.button`
  ${buttonBase}
  background: ${ds.accentInk};
  color: #ffffff;
  border: 1px solid ${ds.accentInk};

  &:hover:not(:disabled) {
    background: ${ds.accentInkHover};
    border-color: ${ds.accentInkHover};
  }
`;

export const SecondaryButton = styled.button`
  ${buttonBase}
  background: ${ds.bgSurface};
  color: ${ds.textPrimary};
  border: 1px solid ${ds.borderDefault};

  &:hover:not(:disabled) {
    background: ${ds.bgMuted};
    border-color: ${ds.borderStrong};
  }
`;
